<template>
    <div>
        <div class="px-4 pt-10 pb-5">
            <div class="w-full text-center">
                <h2 v-text="$t('GOT_MORE_QUESTIONS')"></h2>
            </div>
            <div class="theIntroductions-moreHelp__container w-full mx-auto md:w-2/3">
                <!-- Telephone -->
                <div class="centerItems">
                    <img src="@/assets/images/decoration/telephone-icon.png" alt="Call">
                    <a class="link" href="tel:+442083966696">0208 396 6696</a>
                </div>

                <!-- Email -->
                <div class="centerItems">
                    <img src="@/assets/images/decoration/email-icon.png" alt="Email">
                    <email-us></email-us>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import emailUs from '@/components/structure/navigation/navigation/EmailUs';

export default {
    name: 'GotMoreQuestions',
    components: {
        emailUs,
    },
};
</script>

<style lang="scss" scoped>
.centerItems {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    margin: 10px;
    img {
        width: 30px;
        height: auto;
        margin-right: 20px;
    }
}
</style>
